export default __webpack_public_path__ + "static/img1-d25109f4b7a6720b1395a04fa55713f3.png";